var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUsersIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.875 11.2266C15.355 11.0422 16.5002 9.77971 16.5002 8.24977C16.5002 6.71983 15.355 5.45738 13.875 5.27295C14.5753 6.06626 15.0002 7.10839 15.0002 8.24977C15.0002 9.39115 14.5753 10.4333 13.875 11.2266Z",
    fill: "#777C80"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0002 18.0001C18.0002 18.4143 18.336 18.7501 18.7502 18.7501C19.1644 18.7501 19.5002 18.4143 19.5002 18.0001V16.5001C19.5002 14.505 17.9422 12.8739 15.9766 12.7568C16.7656 13.4557 17.3693 14.3591 17.7044 15.3841C17.8926 15.713 18.0002 16.094 18.0002 16.5001V18.0001Z",
    fill: "#777C80"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.25 14.25C7.00736 14.25 6 15.2574 6 16.5V18C6 18.4142 5.66421 18.75 5.25 18.75C4.83579 18.75 4.5 18.4142 4.5 18V16.5C4.5 14.4289 6.17893 12.75 8.25 12.75H12.75C14.8211 12.75 16.5 14.4289 16.5 16.5V18C16.5 18.4142 16.1642 18.75 15.75 18.75C15.3358 18.75 15 18.4142 15 18V16.5C15 15.2574 13.9926 14.25 12.75 14.25H8.25Z",
    fill: "#777C80"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5 6.75C9.67157 6.75 9 7.42157 9 8.25C9 9.07843 9.67157 9.75 10.5 9.75C11.3284 9.75 12 9.07843 12 8.25C12 7.42157 11.3284 6.75 10.5 6.75ZM7.5 8.25C7.5 6.59315 8.84315 5.25 10.5 5.25C12.1569 5.25 13.5 6.59315 13.5 8.25C13.5 9.90685 12.1569 11.25 10.5 11.25C8.84315 11.25 7.5 9.90685 7.5 8.25Z",
    fill: "#777C80"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsersIcon);
export default __webpack_public_path__ + "static/media/usersIcon.d75ddb602b95dbeb48d1c23eec855c24.svg";
export { ForwardRef as ReactComponent };